import React from 'react';
import { RuleGroup } from 'src/components-bl/Collections';
import {
  OnDeleteRuleGroupCallback,
  OnAddRuleCallback,
  OnDeleteRuleCallback,
  OnEditRuleCallback,
} from '../types';
import { CollectionRuleGroup } from '../CollectionRuleGroup';
import { ParseJoiValidateResponse } from '../../../../../utils';
import { ShopDataField } from '../../../../../services';

interface CollectionRulesGroupListProps {
  shopId: number;
  ruleGroups: RuleGroup[];
  onDeleteRuleGroup: OnDeleteRuleGroupCallback;
  onAddRule: OnAddRuleCallback;
  onDeleteRule: OnDeleteRuleCallback;
  onEditRule: OnEditRuleCallback;
  dataFields: ShopDataField[] | undefined;
  errors: ParseJoiValidateResponse<{ ruleGroups: RuleGroup[] }>;
  isReadOnly?: boolean;
}

export const CollectionRulesGroupList: React.FC<CollectionRulesGroupListProps> = ({
  ruleGroups,
  onDeleteRuleGroup,
  onAddRule,
  onDeleteRule,
  onEditRule,
  dataFields,
  shopId,
  errors,
  isReadOnly = false,
}) => {
  return (
    <>
      {ruleGroups.map((ruleGroup, index) => (
        <CollectionRuleGroup
          shopId={shopId}
          key={ruleGroup.id}
          ruleGroup={ruleGroup}
          index={index}
          onDeleteRuleGroup={onDeleteRuleGroup}
          onAddRule={onAddRule}
          onDeleteRule={onDeleteRule}
          onEditRule={onEditRule}
          dataFields={dataFields}
          errors={errors}
          isReadOnly={isReadOnly}
        />
      ))}
    </>
  );
};
